import React from 'react';
import styled from 'styled-components';
import { DarkenSlightly } from '../../styles/themes';
import { HelpWrapper } from './HelpWrapper';

export function Journaling() {
  return (
    <HelpWrapper>
      <h1>Journaling with exegesis</h1>
      <p>
        Journaling works best when it's totally frictionless, and you're able to
        just write down whatever's on your mind. Here are some tips for
        stream-of-consciousness journaling with exegesis.
      </p>
      <h2>Record disparate thoughts</h2>
      <HelpImage src="/help_images/disparate_thoughts.gif" />
      <p>
        To start, just write down whatever's on your mind. That could be tasks
        you need to get done, random shower thoughts, business ideas,
        conversations you had with a friend - anything.
      </p>
      <p>
        Use tags to organize afterwards.{' '}
        <b>
          You can leave tags by using the # key, or by selecting text and
          inputting tags.
        </b>
      </p>
      <h2>Find your thoughts later</h2>
      <HelpImage src="/help_images/journal_tagbrowser.gif" />
      <p>
        Later, when you want to find those todo tasks, random shower thoughts,
        business ideas, and conversations you wrote down earlier, you can use
        the tag browser.
      </p>
      <h2>Fun things to record in a journal</h2>
      <h3>Gratitude</h3>
      <p>
        <HelpImage src="/help_images/gratitude.png" />
        One fun thing to record in a journal are things you feel grateful for.
        By leaving a gratitude tag in your daily journal entries, you can keep
        track of the things in your life you feel thankful for.
      </p>
      <h3>Personal reflections</h3>
      <p>
        <HelpImage src="/help_images/personal-reflection.png" />
        Some people enjoy using a tag to keep track of general personal
        reflections on their lives.
      </p>
      <h3>Goals</h3>
      <p>
        <HelpImage src="/help_images/goals.png" />
        It can also be fun to keep a tag keeping track of goals you have.
      </p>
      <h3>Favorite quotes</h3>
      <p>
        <HelpImage src="/help_images/quotes.png" />
        Keeping a quotes tag can help you keep track of nice quotes you come
        across.
      </p>
      <p>
        When you're feeling reflective, use the tag browser to return to browse
        through your goals, personal reflections, and the things you feel
        grateful for.
      </p>
    </HelpWrapper>
  );
}

export const HelpImage = styled.img`
  background-color: ${DarkenSlightly};
  border-radius: 30px;
  display: block;
  /* border: 1px solid black; */
  width: 100%;
  margin-bottom: 10px;
  filter: brightness(92.5%);
`;
